import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import './index.css'
import './i18n'
import {AppRouter} from '@/routes'
import {persistor, store} from './store'
import {DialogProvider} from './contexts/DialogContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DialogProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter/>
        </PersistGate>
      </Provider>
    </DialogProvider>
  </StrictMode>,
)
